import { Navigate, Route, Routes } from "react-router-dom";
import { MarketingLayout } from "./MarketingLayout";
import { Landing } from "./pages/Landing";
import { Features } from "./pages/Features";
import { Pricing } from "./pages/Pricing";
import { About } from "./pages/About";
import { Faq } from "./pages/Faq";
import { Terms } from "./pages/Terms";
import { Privacy } from "./pages/Privacy";

/**
 * The public marketing site served at `/` (see main.tsx for the split between
 * this and the authenticated app mounted at `/app`). Every page is real content
 * and every product CTA hands off to the app's existing auth via <a href="/app">.
 */
export function MarketingSite() {
  return (
    <Routes>
      <Route path="/" element={<MarketingLayout />}>
        <Route index element={<Landing />} />
        <Route path="features" element={<Features />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="about" element={<About />} />
        <Route path="faq" element={<Faq />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        {/* Unknown public path → home. Deep app links (/app/*) never reach this
            router; main.tsx routes them to the app bundle instead. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
